import { useState, useEffect } from 'react';
import { Flex, Button, Tooltip, Form } from 'antd';
import { spacing, buttonStyle } from '../../theming';
import StatusForm from './statusForm';
import classes from './style.module.scss';
import { useMedia } from './../../hooks/useMediaQuery';
import { AnimatePresence, motion } from 'framer-motion';

export default function EditStatus({ t, statuses, colors, handleOpenDeleteModal, handleUpdateStatus, loading }) {
    const [statusesToChange, setStatusesToChange] = useState(statuses);
    const [form] = Form.useForm();
    const { isSmallDevice } = useMedia();

    useEffect(() => {
        setStatusesToChange(statuses);
    }, [statuses]);

    const handleChange = (index, field, value) => {
        const newStatusList = statusesToChange.map((status, idx) => {
            if (idx === index) {
                return { ...status, [field]: value };
            }
            return status;
        });

        setStatusesToChange(newStatusList);
    };

    const itemAnimation = {
        initial: { opacity: 0, height: 0 },
        animate: { opacity: 1, height: 'auto' },
        exit: { opacity: 0, height: 0 },
    };

    return (
        <Form
            form={form}
            layout="vertical"
            name="edit_status"
            className={classes.form}
            onFinish={() => {
                handleUpdateStatus(statusesToChange);
            }}
        >
            <AnimatePresence initial={false}>
                {statusesToChange
                    ?.sort((a, b) => a.statusOrder - b.statusOrder)
                    .map((status, index) => (
                        <motion.div key={status.statusOrder} {...itemAnimation} transition={{ duration: 0.2 }}>
                            <Flex
                                align={!isSmallDevice && 'center'}
                                justify="space-between"
                                gap={isSmallDevice ? spacing[2] : spacing[3]}
                            >
                                <StatusForm
                                    status={status}
                                    index={index}
                                    colors={colors}
                                    t={t}
                                    handleChange={handleChange}
                                />
                                <Tooltip
                                    title={statusesToChange.length === 4 ? t('statuses.tooltip.minLimitReached') : ''}
                                >
                                    <Button
                                        icon={<i className="fi-rr-trash" />}
                                        type="link"
                                        onClick={() => {
                                            statusesToChange.length > 4 && handleOpenDeleteModal(status.id);
                                        }}
                                        loading={loading.delete === status.id}
                                        className={classes['delete-button']}
                                    />
                                </Tooltip>
                            </Flex>
                        </motion.div>
                    ))}
            </AnimatePresence>
            <Button
                type="primary"
                htmlType="submit"
                style={{
                    ...(isSmallDevice ? buttonStyle.medium : buttonStyle.large),
                }}
                loading={loading.update}
            >
                {t('edit-status.save')}
            </Button>
        </Form>
    );
}
